<div class="unsaved-changes-dialog">
  <mat-dialog-content>
    <div class="mb-3">
      <h3 class="header">Unsaved Changes</h3>
      <p>You have unsaved changes on the Customer Details (KYC/AML) tab. Leaving this tab will discard those changes.</p>
      @if (unsavedChanges.length) {
        <p>The following individuals have unsaved changes:</p>
        <ul class="changes-list">
          @for (changes of unsavedChanges; track changes) {
            <li>
              {{changes}}
            </li>
          }
        </ul>
      }
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="width-100">
      <button color="primary" (click)="onStay()" mat-stroked-button>Stay on this tab</button>
      <button color="warn" (click)="onLeaveWithoutSaving()" mat-stroked-button>Leave without saving</button>
    </div>
  </mat-dialog-content>
</div>
